<template>
  <v-container fluid class="account">
    <v-container class="px-0 px-md-3">
      <v-row class="d-none d-md-block">
        <breadcrumbs :breadcrumbs="breadcrumbs" />
      </v-row>
       <div class="text-right w-md-50 mt-5" v-if="profileUser.idVerificationStatus == '' || profileUser.idVerificationStatus == null" >
            <!-- <v-btn id="veriff-root" small color="appGreen" class="white--text" >
              Invite new members
              <v-icon small class="ml-2">mdi-send</v-icon>
            </v-btn> -->
            <span id="veriff-root"> </span>
          </div>
          <div class="text-right w-md-50 mt-5" v-else >
            <!-- <v-btn id="veriff-root" small color="appGreen" class="white--text" >
              Invite new members
              <v-icon small class="ml-2">mdi-send</v-icon>
            </v-btn> -->
            <span > ID Verification Status: {{ profileUser.idVerificationStatus | toUpperCase }} </span>
          </div>

          <!-- <div class="text-right w-md-50" v-else>
            ID Verification Status: {{user.idVerificationStatus}}
          </div> -->
    <!-- <div id='veriff-root' v-if="user.idVerificationStatus == '' || user.idVerificationStatus == null" style="width:400px"></div>
          <div v-else> ID Verification Status: {{user.idVerificationStatus}} </div> -->
      <v-row class="mt-md-5 mt-0">
        <div class="sidebar d-none d-md-block">
          <v-list dense>
            <v-subheader>My Account</v-subheader>
            <v-list-item-group v-model="item" color="primary">
              <v-list-item v-for="(item, i) in items" :key="i" :to="item.link">
                <v-list-item-icon>
                  <v-icon v-text="item.icon" color="#aaaaaa"></v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title v-text="item.text"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item @click="logout">
                <v-list-item-icon>
                  <v-icon color="#aaaaaa">logout</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Logout</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </div>
        <v-col cols="12" :lg="isWide" class="right-panel">
          <router-view></router-view>
        </v-col>
      </v-row>
    </v-container>
    <home-footer class="d-none d-md-block" />
  </v-container>
</template>

<script>
import Breadcrumbs from "@/components/Shared/Breadcrumbs/Breadcrumbs.vue";
import HomeFooter from "@/components/Shared/HomeFooter/HomeFooter.vue";
import { mapState } from "vuex";
import { Veriff } from '@veriff/js-sdk';


export default {
  name: "AccountComponent",
  components: {
    Breadcrumbs,
    HomeFooter
  },
  mounted() {
    
    const veriff = Veriff({
        host: 'https://stationapi.veriff.com',
        apiKey: '4bad3a09-7fd5-48af-a8a1-5c34fe4ee6bd',
        parentId: 'veriff-root',
        onSession: function(err, response) {
          window.open(response.verification.url, '_blank')
        }
      });
  veriff.setParams({
    person: {
      id: this.user.uid,
      givenName: this.user.ufirstname,
      lastName: this.user.ulastname
    },
    vendorData: this.user.uid
  });
  
  // if (this.profileUser.idVerificationStatus !== 'submitted' && this.profileUser.idVerificationStatus !== 'started' && this.profileUser.idVerificationStatus !== 'succcess') {
   veriff.mount({
          submitBtnText: 'Verify Your Identity',
          submitBtnColor: 'green'

    })
  },
  filters: {
    toUpperCase: function (string) {
      return string.toUpperCase()
    }
  },
  data: () => ({
    breadcrumbs: ["Acount Info", "Company Info"],
    item: 1
  }),
  computed: {
    ...mapState({
      user: state => state.auth.user,
      token: state => state.auth.token,
      profileUser: state => state.user.user

    }),
    items() {
      let menuItems = [ {
          text: "Personal Info",
          icon: "mdi-account",
          link: "/account/personal-info"
        }];

      if (this.token && this.user.usurgery !== null && this.user.urole == 'admin') {
        menuItems.push({
          text: "Company Info",
          icon: "mdi-city",
          link: "/account/company-info"
        });

      
        
        
      }
      if (this.token && this.user.usurgery !== null) {
      
      menuItems.push(
       
        { text: "Team",
          icon: "group",
          link: "/account/team"
        },
        { text: "Billing", icon: "mdi-credit-card", link: "/account/billing" },
        { text: "Password", icon: "mdi-lock", link: "/account/password" },
        { text: "Orders", icon: "mdi-medical-bag", link: "/account/orders" },
        { text: "Favourites", icon: "mdi-heart", link: "/account/favourite" }
      );
    

     
     
      }
      return menuItems;
    },
    isWide() {
      switch (this.$route.name) {
        case "orders":
          return 9;
        case "order":
          return 9;
        case "favourite":
          return 9;
        default: {
          return 7;
        }
      }
    }
  },
  methods: {
    logout() {
      this.$store.dispatch('auth/LOGOUT');
      this.$router.push({ name: 'Customer' });
    }
  }
};
</script>
<style lang="scss" src="./Account.scss">


</style>
